/** vendor */
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SearchIcon, FilterIcon } from '@heroicons/react/solid'
import { FilterIcon as FilterIconOutline } from '@heroicons/react/outline'

/** lib */
import Loading from '../UI/Loading'

/** state */
import { getIngredients } from '../../actions/ingredient.actions'

/** components */
import IngredientListItem from './IngredientListItem'
import SearchForm from '../../components/Forms/SearchForm'

export default function IngredientsTab() {
    const dispatch = useDispatch()

    const [currentSearchTerm, setCurrentSearchTerm] = useState('')
    const [currentCategory, setCurrentCategory] = useState(undefined)

    const [loading, setLoading] = useState(false)
    const [showCategorySelect, setShowCategorySelect] = useState(false)
    const [showSearch, setShowSearch] = useState(true)
    const [showIngredientDetailsModal, setShowShowIngredientDetailsModal] = useState(false)

    const [ingredients, setIngredients] = useState([])
    const ingredientsState = useSelector(state => state?.ingredients)
    const categoryOptions = useSelector(state => state.form_options?.category_options || [])

    const toggleIngredientDetailsModal = e => { 
        setShowShowIngredientDetailsModal(!showIngredientDetailsModal) 
    }

    const toggleCategoryFilter = e => { 
        setShowCategorySelect(true) 
        setShowSearch(false)
    }

    const toggleSearch = e => { 
        setShowSearch(true)
        setShowCategorySelect(false)
        
        setTimeout(() => { 
            if (!showSearch) {
                document.getElementById('recipeSearchInput').focus() 
            } 
        }, 100)
    }

    const filterIngredients = () => {
        /// filter ingredients first last names and category
    }

    const handleOnSelectCategory = (category_id) => {
        if(category_id === currentCategory.category_id) {
            return
        }

        setCurrentCategory(category_id)
    }

    const handleOnSearchIngredient = (searchString) => {
        if(searchString === currentSearchTerm) {
            return
        }

        setCurrentSearchTerm(searchString)


    }
    
    const fetchIngredients = async () => {
        setLoading(true)
        await dispatch(getIngredients())
        setLoading(false)        
    }

    useEffect(() => {
        if(ingredientsState && ingredientsState !== ingredients && ingredients.length < 1) {
            setIngredients(ingredientsState)

            console.warn('ingredientsState', ingredientsState);
        }
    }, [ingredientsState])

    useEffect(() => {
       fetchIngredients()
    }, [])

    return (
        <div className="h-[120px] items-center w-full mx-auto">
            {
                loading  
                    ?   <div className="h-[60vh] relative pt-40">
                            <Loading />
                        </div>
                    :   ingredients 
                            ? ingredients?.map(
                                (ingredient, i) =>  
                                    <div key={i} className="w-full pt-2 px-2 cursor-pointer odd:bg-an_white-dark hover:bg-an_white-darker1">
                                        <IngredientListItem 
                                            ingredient={ingredient} 
                                            key={ingredient.ingredient_id} 
                                        />
                                    </div>
                                )
                            : <div className="text-center">No Ingredients Found</div> 
            }


            {
                !loading &&
                    <div className="fixed h-[42px] bottom-4 left-0 p-2 w-full flex align-middle items-center justify-center">
                        <div className="flex align-middle items-center justify-center w-full max-w-xl mx-auto">
                            <div className="flex justify-end w-12">
                                <div className="relative">
                                    <SearchIcon className="h-8 w-8 inline-flex text-an_green-dark flex-shrink-0" onClick={toggleSearch} />
                                    { 
                                        currentSearchTerm?.length > 0 && 
                                            <div className="rounded-full w-2 h-2 top-0 right-0 absolute border border-white bg-an_green"></div> 
                                    }
                                </div>
                            </div>
                            
                            <div className="flex-grow">  
                                { 
                                    showSearch && 
                                        <div className="px-2 w-full">
                                            <SearchForm 
                                                onSearch={handleOnSearchIngredient} 
                                                currentSearchString={currentSearchTerm}  
                                            />
                                        </div>
                                }

                                {
                                    showCategorySelect &&
                                        <div className="px-2 w-full">
                                            <select 
                                                onSelect={handleOnSelectCategory}
                                                className="border border-black text-black text-sm rounded-lg block w-full p-2.5"
                                                placeholder="filter by category"
                                            >
                                                <option style={{ color: 'red' }}>filter by category</option>
                                                {
                                                    categoryOptions?.map((c) => {
                                                        return <option value={c?.value}>{c?.name}</option>
                                                    })
                                                }
                                            </select>
                                        </div>
                                }
                            </div>

                            <div className="relative w-12">
                                {
                                    currentCategory 
                                        ? <FilterIcon className="h-6 w-6 inline-flex text-an_green-dark" onClick={toggleCategoryFilter} /> 
                                        : <FilterIconOutline className="h-6 w-6 inline-flex text-an_green-dark" onClick={toggleCategoryFilter} />
                                }
                            </div>
                        </div>
                    </div>
            }
        </div>
    )
}